document.addEventListener('DOMContentLoaded', () => {
	// Select the product item element from the form
	const packsWrapper = document.querySelector('.packs-wrapper');
	// Push data to the data layer when the product item page is loaded
	pushDataLayer('view_item', packsWrapper, 'isProductItem');
	
});
